import { IconDefinition } from "./types";

const message: IconDefinition = {
  iconName: "message",
  width: 512,
  height: 512,
  svgPathData:
    "M128 544l0-96-128 0 0-416 512 0 0 416-224 0-160 96zm48-84.8l98.7-59.2 189.3 0 0-320-416 0 0 320 128 0 0 59.2z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "message",
  unicode: 0xf27a,
};

export { message };
